import styles from './CallMe.scss'
import { withTranslation } from 'react-i18next'
import { Typography, Button, Row, Column, Callout } from '@vp/swan'

const DisabledCallMe = (props) => {
  const { t, callMeOpen, callMeResponse, callMeDisabled } = props
  const lng = props.locale.toLowerCase().replace('-', '_')

  return (
    <Column className={styles.callmeColumnContainer} span={12}>
      <Row style={{ justifyContent: 'space-between' }}>
        <Typography component="h3" fontSize="x2large">
          {t(`${props.tenant}:call_me.title`, { lng })}
        </Typography>
      </Row>
      <Row pt="5">
        <Typography component="p" fontSize="standard">
          {t(`${props.tenant}:call_me.service_unavailable`, { lng })}{' '}
        </Typography>
      </Row>
      <Row pt="5">
        <Button disabled skin="holiday-white" size="standard" type="button" name="call_me_offline" value="call_me_offline">
          {t(`${props.tenant}:call_me.buttons.call_me_offline.title`, {
            lng,
          })}
        </Button>
      </Row>
    </Column>
  )
}
export default withTranslation()(DisabledCallMe)
